import React from 'react';
import AssetImages from '../constants/images';
import '../constants/AssetsCss';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import { Link } from "react-router-dom";
import '../assets/css/common.css';
import withRouter from '../constants/withRouter';

class TreeView extends React.Component {
    constructor(props) {
        super(props);
        this.searchTextChanged = this.searchTextChanged.bind(this);
        this.searchClicked = this.searchClicked.bind(this);
        this.changeWidth = this.changeWidth.bind(this);
        this.usr = ""
        this.state = {
            searchText: "",
            screenWidth: window.innerWidth
        };
    }
    changeWidth() {
        this.setState({ screenWidth: window.innerWidth });
    }
    componentDidMount() {
        let usr = this.props.history.params.usr;
        if (usr) {
            if (usr.includes(':')) {
                usr = usr.replace(':', '');
            }
            this.usr = usr;
            this.getTree(usr);
        } else {
            this.getTree(localStorage.getItem("username"));
        }
        window.addEventListener('resize', this.changeWidth);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.changeWidth);
    }
    searchTextChanged(event) {
        this.setState({ searchText: event.target.value });
    }
    async searchClicked() {
        this.props.history.push({
            pathname: "/home/treeview/" + this.state.searchText,
        });
    }
    componentWillReceiveProps(props) {
        console.log(props);
        let usr = props.history.params.usr;
        if (usr) {
            if (usr.includes(':')) {
                usr = usr.replace(':', '');
            }
            this.usr = usr;
            this.getTree(usr);
        } else {
            this.getTree(localStorage.getItem("username"));
        }
    }
    async getTree(memberid) {
        let obj = {};
        for (let i = 0; i < 15; i++) {
            obj["username" + i] = "Add";
            let element = document.getElementById('user' + i);
            element.src = AssetImages.Vacanticon;
            element.setAttribute("data-tooltip-html", "");
            if (i === 14) {
                this.setState(obj);
            }
        }

        let json = {
            memberid: memberid
        }
        let res = await GetORPostAsync("GetPlacementGenology.ASP", "POST", JSON.stringify(json), localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        console.log(res);
        for (let i = 0; i < 15; i++) {
            let item = res.items[i];
            if (item) {
                let element = document.getElementById('user' + item.Treepos);
                element.src = item.package === "active" ? AssetImages.activeicon : AssetImages.inactiveicon;
                element.setAttribute("data-tooltip-html", "<div className='card card-body'> <table cellspacing='2' cellpadding='5' border='1' style='text-align:center;'><tbody><tr><td color='#ffffff' colSpan='4'  height='10' style='background-color:rgba(254, 74, 67)'>&nbsp;<strong style='color:#ffffff'>" + item.memberid + " - " + item.membername + "</strong>&nbsp;&nbsp;</td></tr><tr ><td height='10'><b>Join date</b></td><td colSpan='3' height='10'>&nbsp;<strong>" + item.dateofjoining + "</strong>&nbsp;&nbsp;</td></tr><tr ><td height='10'><b>Package</b></td><td colSpan='3' height='10'>&nbsp;<strong>" + item.packageamount + "</strong>&nbsp;&nbsp;</td></tr><tr ><td height='10'><b>Sponsor ID</b></td><td colSpan='3' height='10'>&nbsp;<strong>" + item.sponsorid + "</strong>&nbsp;&nbsp;</td></tr><tr ><td height='10'><b>&nbsp;Business Details</b></td><td height='10'>&nbsp;&nbsp;<strong>Left</strong>&nbsp;&nbsp;</td><td height='20'>&nbsp;&nbsp;<strong>Right</strong>&nbsp;&nbsp;</td><td height='10'>&nbsp;<b> Total</b>&nbsp;</td></tr><tr ><td height='10'>&nbsp; Total BV&nbsp;</td><td height='10'>&nbsp;&nbsp;" + item.leftbtc + "&nbsp;</td><td height='10'>&nbsp;&nbsp;" + item.rightbtc + "&nbsp;&nbsp;</td><td height='10'>&nbsp;" + (parseFloat(item.leftbtc) + parseFloat(item.rightbtc)) + "&nbsp;</td></tr><tr ><td height='10'>&nbsp;&nbsp;Carry Forward&nbsp;</td><td height='10'>&nbsp;&nbsp;" + item.carryforwardleft + "&nbsp;&nbsp;</td><td height='20'>&nbsp;" + item.carryforwardright + "&nbsp;&nbsp;</td><td height='10'>&nbsp;" + (parseFloat(item.carryforwardleft) + parseFloat(item.carryforwardright)) + "&nbsp;</td></tr><tr ><td height='10'>&nbsp;&nbsp;Total Team&nbsp;</td><td height='10'>&nbsp;&nbsp;" + item.leftteam + "&nbsp;&nbsp;</td><td height='20'>&nbsp;" + item.rightteam + "&nbsp;&nbsp;</td><td height='10'>&nbsp;" + (parseFloat(item.leftteam) + parseFloat(item.rightteam)) + "&nbsp;</td></tr></tbody></table></div>");
                let obj = {};
                obj["username" + item.Treepos] = item.memberid;
                this.setState(obj);
            }
        }
    }
    render() {
        return (<div>
            <div className="page-header">
                <div className="page-leftheader">
                    <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                    {/* <ol className="breadcrumb">
                        <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                        <li className="breadcrumb-item active" aria-current="page"><label>Tree View</label></li>
                    </ol> */}
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Tree View</h3>
                        </div>
                        <div className="col-lg-12 row p-3">
                            <input type="text" onChange={this.searchTextChanged} placeholder="Username" value={this.state.searchText} className="ml-5 mt-lg-5 col-lg-4 col-sm-12" />
                            <input type="button" value="Search" onClick={this.searchClicked} className="col-lg-2 col-sm-12 ml-5 mr-lg-5 mt-5 btn btn-color-1" />
                        </div>

                        {/* <div className="col-lg-12 row mt-2">
                            <Link to={`/register/${this.usr ? this.usr : localStorage.getItem("username")}&Left`}>
                                <h4 className="text-color-3 ml-3" style={{ cursor: "pointer" }} >Click Here to Register New Affiliate <br /> on your Left Side</h4>
                            </Link>
                            <Link className="ml-auto" to={`/register/${this.usr ? this.usr : localStorage.getItem("username")}&Right`}>
                                <h4 className="text-color-3" style={{ cursor: "pointer" }} >Click Here to Register New Affiliate <br /> on your Right Side</h4>
                            </Link>

                        </div> */}


                        <div className="card-body mb-3 mt-3">
                            <div className="col-lg-12 text-center">
                                <img className='treeimage__style' src={AssetImages.Vacanticon} id="user0" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' /><br />
                                <h6 className="mt-2 treetext__style">{this.state.username0}</h6>
                                <img className='mt-2' src={AssetImages.barimage} style={{ width: "50%" }} alt='' />
                            </div>
                            <div className="col-lg-12" style={{ display: 'flex' }}>

                                <div className="col-lg-6 text-center">
                                    <Link to={`${this.state.username1 === "Add" ? `/register/${this.state.username0}&Left` : `/home/treeview/${this.state.username1}`}`}>
                                        <img className='treeimage__style' src={AssetImages.Vacanticon} id="user1" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' /><br />
                                        <h6 className="mt-2 treetext__style">{this.state.username1}</h6>
                                        <img className='mt-2' src={AssetImages.barimage} style={{ width: "50%" }} alt='' />
                                    </Link>
                                </div>

                                <div className="col-lg-6 text-center">
                                    <Link to={`${this.state.username2 === "Add" ? `/register/${this.state.username0}&Right` : `/home/treeview/${this.state.username2}`}`}>
                                        <img className='treeimage__style' src={AssetImages.Vacanticon} id="user2" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' /><br />
                                        <h6 className="mt-2 treetext__style">{this.state.username2}</h6>
                                        <img src={AssetImages.barimage} className="mt-2" style={{ width: "50%" }} alt='' />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-12" style={{ display: 'flex' }}>
                                <div className="col-lg-3 text-center">
                                    <Link to={`${this.state.username3 === "Add" ? `/register/${this.state.username1 !== "Add" ? this.state.username1 : ""}&Left` : `/home/treeview/${this.state.username3}`}`}>
                                        <img className='treeimage__style' src={AssetImages.Vacanticon} id="user3" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' /><br />
                                        <h6 className="mt-2 treetext__style">{this.state.username3}</h6>
                                        <img style={{ display: this.state.screenWidth > 520 ? '' : 'none', width: "50%" }} src={AssetImages.barimage} className="mt-2" alt='' />
                                    </Link>
                                </div>

                                <div className="col-lg-3 text-center">
                                    <Link to={`${this.state.username4 === "Add" ? `/register/${this.state.username1 !== "Add" ? this.state.username1 : ""}&Right` : `/home/treeview/${this.state.username4}`}`}>
                                        <img className='treeimage__style' src={AssetImages.Vacanticon} id="user4" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' /><br />
                                        <h6 className="mt-2 treetext__style">{this.state.username4}</h6>
                                        <img style={{ display: this.state.screenWidth > 520 ? '' : 'none', width: "50%" }} src={AssetImages.barimage} className="mt-2" alt='' />
                                    </Link>
                                </div>
                                <div className="col-lg-3 text-center">
                                    <Link to={`${this.state.username5 === "Add" ? `/register/${this.state.username2 !== "Add" ? this.state.username2 : ""}&Left` : `/home/treeview/${this.state.username5}`}`}>
                                        <img className='treeimage__style' src={AssetImages.Vacanticon} id="user5" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' /><br />
                                        <h6 className="treetext__style mt-2">{this.state.username5}</h6>
                                        <img style={{ display: this.state.screenWidth > 520 ? '' : 'none', width: "50%" }} src={AssetImages.barimage} className="mt-2" alt='' />
                                    </Link>
                                </div>

                                <div className="col-lg-3 text-center">
                                    <Link to={`${this.state.username6 === "Add" ? `/register/${this.state.username2 !== "Add" ? this.state.username2 : ""}&Right` : `/home/treeview/${this.state.username6}`}`}>
                                        <img className='treeimage__style' src={AssetImages.Vacanticon} id="user6" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' /><br />
                                        <h6 className="mt-2 treetext__style">{this.state.username6}</h6>
                                        <img style={{ display: this.state.screenWidth > 520 ? '' : 'none', width: "50%" }} src={AssetImages.barimage} className="mt-2" alt='' />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-12" style={{ display: this.state.screenWidth > 520 ? 'flex' : 'none' }}>
                                <div className="col-lg-6" style={{ display: 'flex' }}>
                                    <div className="col-lg-3 text-center">
                                        <Link to={`${this.state.username7 === "Add" ? `/register/${this.state.username3 !== "Add" ? this.state.username3 : ""}&Left` : `/home/treeview/${this.state.username7}`}`}>
                                            <img className='treeimage__style' src={AssetImages.Vacanticon} id="user7" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' />
                                            <h6 className="mt-2 treetext__style">{this.state.username7}</h6>
                                        </Link>
                                    </div>

                                    <div className="col-lg-3 text-center">
                                        <Link to={`${this.state.username8 === "Add" ? `/register/${this.state.username3 !== "Add" ? this.state.username3 : ""}&Right` : `/home/treeview/${this.state.username8}`}`}>
                                            <img className='treeimage__style' src={AssetImages.Vacanticon} id="user8" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' />
                                            <h6 className="mt-2 treetext__style">{this.state.username8}</h6>
                                        </Link>
                                    </div>
                                    <div className="col-lg-3 text-center">
                                        <Link to={`${this.state.username9 === "Add" ? `/register/${this.state.username4 !== "Add" ? this.state.username4 : ""}&Left` : `/home/treeview/${this.state.username9}`}`}>
                                            <img className='treeimage__style' src={AssetImages.Vacanticon} id="user9" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' />
                                            <h6 className="mt-2 treetext__style">{this.state.username9}</h6>
                                        </Link>
                                    </div>

                                    <div className="col-lg-3 text-center" >
                                        <Link to={`${this.state.username10 === "Add" ? `/register/${this.state.username4 !== "Add" ? this.state.username4 : ""}&Right` : `/home/treeview/${this.state.username10}`}`}>
                                            <img className='treeimage__style' src={AssetImages.Vacanticon} id="user10" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' />
                                            <h6 className="mt-2 treetext__style">{this.state.username10}</h6>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-lg-6" style={{ display: 'flex' }}>
                                    <div className="col-lg-3 text-center">
                                        <Link to={`${this.state.username11 === "Add" ? `/register/${this.state.username5 !== "Add" ? this.state.username5 : ""}&Left` : `/home/treeview/${this.state.username11}`}`}>
                                            <img className='treeimage__style' src={AssetImages.Vacanticon} id="user11" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' />
                                            <h6 className="mt-2 treetext__style">{this.state.username11}</h6>
                                        </Link>
                                    </div>

                                    <div className="col-lg-3 text-center">
                                        <Link to={`${this.state.username12 === "Add" ? `/register/${this.state.username5 !== "Add" ? this.state.username5 : ""}&Right` : `/home/treeview/${this.state.username12}`}`}>
                                            <img className='treeimage__style' src={AssetImages.Vacanticon} id="user12" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' />
                                            <h6 className="mt-2 treetext__style">{this.state.username12}</h6>
                                        </Link>
                                    </div>
                                    <div className="col-lg-3 text-center">
                                        <Link to={`${this.state.username13 === "Add" ? `/register/${this.state.username6 !== "Add" ? this.state.username6 : ""}&Left` : `/home/treeview/${this.state.username13}`}`}>
                                            <img className='treeimage__style' src={AssetImages.Vacanticon} id="user13" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' />
                                            <h6 className="mt-2 treetext__style">{this.state.username13}</h6>
                                        </Link>
                                    </div>

                                    <div className="col-lg-3 text-center">
                                        <Link to={`${this.state.username14 === "Add" ? `/register/${this.state.username6 !== "Add" ? this.state.username6 : ""}&Right` : `/home/treeview/${this.state.username14}`}`}>
                                            <img className='treeimage__style' src={AssetImages.Vacanticon} id="user14" data-iscapture="true" data-tooltip-id="main" data-tooltip-html="" alt='' />
                                            <h6 className="mt-2 treetext__style">{this.state.username14}</h6>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            
                        <ReactTooltip id="main" type='light' place='bottom' />

                            <div className='d-flex align-items-center ml-auto mr-auto' style={{ width: 'fit-content', marginTop: 50 }}>
                                <div className="text-center ml-2 mr-2">
                                    <img src={AssetImages.activeicon} className="treeimage__style" />
                                    <h5 className="treetext__style mt-2">Active</h5>
                                </div>
                                <div className="text-center ml-2 mr-2">
                                    <img src={AssetImages.inactiveicon} className="treeimage__style" />
                                    <h5 className="treetext__style mt-2">Inactive</h5>
                                </div>
                                <div className="text-center ml-2 mr-2">
                                    <img src={AssetImages.Vacanticon} className="treeimage__style" />
                                    <h5 className="treetext__style mt-2">Vacant</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default withRouter(TreeView);